import { useEffect, useState } from "react";
import { Reveal } from "../components/Reveal";
import { api } from "../lib/api";
import { Star, Quote } from "lucide-react";

export function SuccessStories() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <section id="stories" className="section-pad" data-testid="stories-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal className="text-center">
          <span className="overline">Success Stories</span>
          <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">
            Real learners, real <span className="brand-text">passes</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={(i % 3) * 0.08}>
              <div className="card-soft overflow-hidden h-full flex flex-col" data-testid={`testimonial-${t.id}`}>
                <div className="relative h-52">
                  <img src={t.image} alt={`${t.name} passed with SUK`} className="w-full h-full object-cover" loading="lazy" />
                  <span className="absolute top-3 left-3 brand-gradient text-white text-xs font-bold px-3 py-1 rounded-full">Passed · {t.area}</span>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <Quote size={26} className="text-brand-amber" />
                  <p className="mt-2 text-sm text-neutral-700 leading-relaxed flex-1">"{t.quote}"</p>
                  <div className="mt-4 flex items-center justify-between">
                    <div>
                      <p className="font-semibold text-sm">{t.name}</p>
                      <p className="text-xs text-neutral-400">{t.lesson} lessons</p>
                    </div>
                    <div className="flex gap-0.5">
                      {Array.from({ length: t.rating }).map((_, k) => <Star key={k} size={14} className="fill-brand-amber text-brand-amber" />)}
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
